import React from "react";

const RemoveIcon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 14.13 14.32"
    width={width}
    height={height}
  >
    <path
      fill="#EF5753"
      d="M13.73 2.13h-3.8v-.57A1.56 1.56 0 0 0 8.36 0H5.53a1.56 1.56 0 0 0-1.34 1.58v.55H.4a.4.4 0 0 0 0 .8h1.15l.29 8.75a2.84 2.84 0 0 0 2.76 2.68h4.91a2.83 2.83 0 0 0 2.72-2.67l.29-8.75h1.21a.4.4 0 1 0 0-.8zm-8.74-.57A.75.75 0 0 1 5.6.79h2.75a.76.76 0 0 1 .79.78v.56H4.99zm6.45 10.06a2 2 0 0 1-2 1.9H4.65a2 2 0 0 1-2-1.9l-.3-8.73h9.38z"
    />
  </svg>
);

export default RemoveIcon;



// WEBPACK FOOTER //
// ../shop_main/images/removeIcon.js